import React from "react";
import MainButton from "../components/common/mainButton";
import { useTranslation } from 'react-i18next'



const APP = () => {

  const { t } = useTranslation(['data'])

  return (
    <div className="homePage">
      <div className="content">
        <div className="logo">
          <img src="/media/es/images/logo" />
        </div>
        <div className="homePageTitle">{t('catalogoDeProductos')}</div>
        <div className="image">

        
          <img src="/media/es/images/main_ferrero_img" />
        </div>
        <div className="buttons">
          <div className="button">
            <MainButton link="catalogos" name={t('porCatalogos')} />
          </div>
          <div className="button">
            <MainButton link="categorias" name={t('porCategorias')}  />
          </div>
          <div className="button">
            <MainButton link="marcas" name={t('porMarcas')}  />
          </div>
          <div className="button">
            <MainButton link="/catalogos/new" name={t('crearCatalogo')}  />
          </div>
        </div>
      </div>
    </div>
  );
};

export default APP;
